import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router';
import { CommunityShell, NoticeCard } from '../components/community/Shell';
import { PageSpinner } from '../components/ui';
import { ApiError, apiFetch } from '../lib/api';

type State = { status: 'loading' } | { status: 'missing'; message: string } | { status: 'failed' };

/**
 * mogzo.com/match/<code>: a friend's invite to a match (M31). It opens the game, which joins
 * the match with the code; the game asks guests to sign in.
 */
export function MatchInvite() {
  const { code = '' } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState<State>({ status: 'loading' });

  useEffect(() => {
    let active = true;
    apiFetch<{ game: string; playPath: string }>(`/v1/match-invites/${encodeURIComponent(code)}`)
      .then((invite) => active && navigate(invite.playPath, { replace: true }))
      .catch((error) => {
        if (!active) return;
        if (error instanceof ApiError && [400, 404].includes(error.status)) {
          setState({ status: 'missing', message: error.message });
        } else setState({ status: 'failed' });
      });
    return () => {
      active = false;
    };
  }, [code, navigate]);

  if (state.status === 'loading') return <PageSpinner />;
  return (
    <CommunityShell>
      {state.status === 'missing' ? (
        <NoticeCard title="This invite has run out">
          <p>
            {state.message} <Link to="/">Go to MOGZO</Link>
          </p>
        </NoticeCard>
      ) : (
        <NoticeCard title="Couldn’t open this invite">
          <p>MOGZO didn’t answer. Reload the page to try again.</p>
        </NoticeCard>
      )}
    </CommunityShell>
  );
}
